import React from "react";
import PaymentCycleFormPage from "./PaymentCycleFormPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface PaymentCycleFormPageContainerProps extends RouteProps, withValidUserRoleProps {}

const PaymentCycleFormPageContainer = (props: PaymentCycleFormPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <PaymentCycleFormPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(PaymentCycleFormPageContainer);
